import { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { cn } from '@/app/shared/lib/cn';

export interface AppLinkProps extends LinkProps {
  className?: string;
  external?: boolean;
}

export const AppLink: FC<AppLinkProps> = ({ className, children, external, ...props }) => {
  return (
    <Link
      {...props}
      {...(external && { target: '_blank', rel: 'noreferrer' })}
      className={cn('no-underline outline-none', className)}
    >
      {children}
    </Link>
  );
};
